import { render, staticRenderFns } from "./RelatorioNotasRecebidas.vue?vue&type=template&id=6ebc51fc&scoped=true&"
import script from "./RelatorioNotasRecebidas.vue?vue&type=script&lang=js&"
export * from "./RelatorioNotasRecebidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebc51fc",
  null
  
)

export default component.exports